import type { ReactNode } from "react";
import { Visibility } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Paper, Stack, Typography } from "@mui/material";

type AssessmentQuestionPreviewProps = {
  isVisible: boolean;
  onToggle: () => void;
  children: ReactNode;
};

export function AssessmentQuestionPreview({
  isVisible,
  onToggle,
  children,
}: AssessmentQuestionPreviewProps) {
  return (
    <Stack spacing={1.5} sx={{ mt: 2 }}>
      {!isVisible ? (
        <IconButton
          size="small"
          aria-label="Show preview"
          onClick={onToggle}
          sx={{ alignSelf: "flex-end" }}
        >
          <Visibility fontSize="medium" />
        </IconButton>
      ) : null}
      {isVisible ? (
        <Paper variant="outlined" sx={{ p: 2, backgroundColor: "grey.50" }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ mb: 1.5 }}
          >
            <Typography variant="subtitle2">Assessment Preview</Typography>
            <IconButton
              size="small"
              aria-label="Hide preview"
              onClick={onToggle}
              sx={{ alignSelf: "flex-end" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Stack>
          {children}
        </Paper>
      ) : null}
    </Stack>
  );
}
